import { call, put } from 'redux-saga/effects';
import { getResourcesFailureAction, getResourcesSuccessAction } from '../actions';
import { formateResourceInfoResponse, ResourceLookupService } from '../services';
export function* getResourcesSaga(action, resourceLookupService = ResourceLookupService.getInstance()) {
    try {
        const resourceLookupPayload = action.payload;
        const response = yield call({
            context: resourceLookupService,
            fn: resourceLookupService.getResources
        }, resourceLookupPayload);
        const formattedResponse = formateResourceInfoResponse(response);
        yield put(getResourcesSuccessAction(formattedResponse));
    }
    catch (ex) {
        yield put(getResourcesFailureAction(ex.toString()));
    }
}
//# sourceMappingURL=getResourcesSaga.js.map